<template>
<section class="section">
  <div class="container">
    <h1 class="title">Login</h1>
    <div class="login-wrapper">
      <form class="login" v-model="valid" ref="form" lazy-validation>

        <div class="field">
          <label class="label">Email address or username</label>
          <div class="control">
            <input autofocus class="input is-success" v-model="email" v-validate="'required|alpha'" type="text" name="username" placeholder="Username" />
          </div>
          <span class="help is-success" v-show="errors.has('username')">This username is available</span>
        </div>

        <div class="field">
          <label class="label">Password</label>
          <div class="control">
            <input class="input is-danger" v-model="password" v-validate="'required'" type="password" name="password" placeholder="Password" />           
          </div>
          <span class="help is-danger" v-show="errors.has('password')">{{ errors.first('password') }}</span>
        </div>

        <div class="alert alert-danger" v-if="error">{{ error }}</div>

        <div class="field is-grouped">
          <div class="control">
            <button class="button is-link" @click="submit" :disabled="!valid">Login</button>
          </div>
          <div class="control">
            <button class="button is-text" @click="register">or Register</button>
          </div>
        </div>

        <br/>
        <br/>
      </form>
    </div>
  </div>
</section>
</template>

<script>
// import Api from '@/config/Api'
// import bus from './../../bus'
import {AUTH_REQUEST} from '../../store/actions/auth'

export default {
    name: 'Login',
    data () {
      return {
        email: '',
        password: '',
        error: false,
        valid: true
      }
    },
    methods: {
      async submit(evt) {
        evt.preventDefault()
        const { email, password } = this
        console.log("email:",email)
        console.log("password:",password)
        this.$store.dispatch(AUTH_REQUEST, { email, password }).then(() => {
          this.$router.push('/')
        })

        /*
        Api().post('/api/login', {        
            email: this.username,
            password: this.password,
        })
        .then(response => {
          this.$swal('Great!', 'You are ready to start!', 'success');
          console.log("setting jwtToken:", response.data.token);
          localStorage.setItem('jwtToken', response.data.token);
          bus.$emit('refreshUser');
          this.$router.push({ name: 'home' });
        })
        .catch((error) => {
          console.log("errorrrr:",error);
          const message = error.response.data.message;
          this.$swal('Oh oo!', `${message}`, 'error');
          this.$router.push({ name: 'login' });
        });
        */
      },
      register() {
          this.$router.push({ name: 'register' });
      }
    },
    metaInfo: {
      title: "Login",
      // titleTemplate: null // override the parent template and just use the above title only
    }
}
</script>

<style>
  .login {
    display: flex;
    flex-direction: column;
    width: 300px;
    /* padding: 10px; */
  }
</style>



// WEBPACK FOOTER //
// src/components/accounts/Login.vue